// src/lib/safeParseFloat.js

/**
 * Safely parses a value to float, handling various formats including:
 * - Regular numbers: "12345" -> 12345
 * - Comma-separated numbers: "12,345" -> 12345
 * - Accounting format negatives: "(12,345)" -> -12345
 * - Empty/null values: null, undefined, "", "-" -> null
 */
export const safeParseFloat = (value) => {
  if (value === "-" || value === null || value === undefined || value === "") {
    return null;
  }

  // Convert to string for processing
  let strValue = String(value).trim();

  // Check if value is in accounting format (negative with parentheses)
  const isNegative = strValue.startsWith('(') && strValue.endsWith(')');
  
  if (isNegative) {
    // Remove parentheses and process as negative
    strValue = strValue.slice(1, -1);
  }

  // Remove commas and parse
  const parsed = parseFloat(strValue.replace(/,/g, ""));
  
  if (isNaN(parsed)) {
    return null;
  }

  // Apply negative sign if it was in parentheses
  return isNegative ? -parsed : parsed;
};